import styles from './FilledRanking.css'
import cx from 'classnames'

const FilledRanking = props => {
  const {
    value,
    filled,
    className
  } = props
  const clz = cx(
    styles.FilledRanking,
    className,
    filled ? styles.filled : null
  )
  return (
    <div className={clz}>
      <span className={styles.rankingValue}>
        {value}
      </span>
    </div>
  )
}

export default FilledRanking
